<template>
  <div class="normal-terms">
    <v-row no-gutters>
      <v-col
        cols="12"
        :key="index"
        v-for="(item, index) in list"
        :class="{ 'mb-7': list.length != index + 1 }"
      >
        <div class="term-box">
          <p class="term-box__title">{{ item.title }}</p>
          <p class="term-box__content">{{ item.content }}</p>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isCollapse: false,
      list: [
        {
          title: '제1조 한도거래 및 개별거래',
          content:
            '한도거래 함은 거래 기간중 한도 금액 범위 내에서 즉시 입금 출금을 자유롭게 신청하고 지급받는 것을, 개별거래라 함은 즉시입금 금액을 한도거래 기간 전 또는 만료일에 직접 일시 상환하거나 거래 기간까지 분할하여 상환하는 것을 말한다.',
        },
        {
          title: '제2조 서비스 이용',
          content:
            '1. 신청인(본인)은 카드 입금 계좌가 이용자(본인)가 지정하는 계좌로 제신고 변경된 익일부터 전일 매출에 대한 이자비용등을 제외한 금원을 지급받는다.' + 
            '2. 배달 플랫폼 매출의 경우 신청인(본인)의 요청으로 제신고가 동의된 매출에 한하여 서비스를 진행 한다.',
        },
        {
          title: '제3조 상환방식',
          content:
            '1. 상점에서 입금받는 카드매출,(주)우아한형제들, 주식회사 위대한상상, 쿠팡(주)매출금액의 100%를 매 영업일에 상환하며, 상환되는 금액이 즉시 입금 금액의 원금과 이자의 전액을 상환하기 부족한 경우에는, 비용, 이자, 원금순으로 충당된다'
            + '2. 상환은 개설 계좌에 따라서 펌 뱅킹 혹은 자동이체납부 방식으로 납부한다.'
            + '3. 즉시입금 지급 후 중도상환시 기간에 상관 없이 이에 대한 별도의 수수료는 발생하지 않는다.',
        },
        {
          title: '제4조 지연손해금',
          content:
          '1. 이자, 분할상환금, 분할상환 원리금을 계약 만기일까지 전액 상환하시 못하거나 제5조에 의한 기한의 이익을 상실한 때에는 그 다음날부터 남은 잔액에 대해 연체이자율에 의한 지연손해금을 지급하기로 한다.'
            +'2. 각 카드사 및 배달앱 사정으로 인하여 카드매출대금 입금이 지연되어 추가로 발생하는 이자는 차주(본인)의 고의 또는 과실 여부와 무관하게 이용자(본인)가 부담한다.',
        },
        {
          title: '제5조 감액 · 정지',
          content: '1. 한도거래 여신거래의 경우 국가경제 · 금융사정의 급격한 변동, 신용상태의 현저한 악화 혹은 상점의 카드매출, ㈜우아한형제들 등 배달매출금액이 하락하여 여신거래에 중대한 지장을 초래한다고 판단될 때에는, ㈜펀다에이아이는 통지에 의하여 여신(한도)금액을 줄이거나, 거래기간에 불구하고 여신실행을 일시 정지 할 수 있다.'
            + '2. 단, 감액 · 정지 사유가 해소 된 경우 서비스 제공자의 판단에 따라 거래를 정상화 할 수 있다.',
        },
        {
          title: '제6조 계약의 연장',
          content: `본 약정은 신청일로부터 1개월간 유효하며, 1개월후에는 다시 약정을 체결하여야 한다. 단, 계약조건등의 변동 사유가 없다면(신용정보포함),동일한 조건으로 동일기간 계약의 기간은 자동 연장된다.`,
        },
        {
          title: '제7조 계약 해지',
          content: `1. 이용자(본인)가 본 약정의 변경 및 해제 또는 해지의 의사를 서비스 제공자에게 통지하면 서비스 제공자는 즉시 추가적인 즉시 입금 지급을 중지한다.
2 신청인(본인)은 기 발생한 즉시 입금 금액이 전액 변제된 경우에 한하여 카드매출대금 지급계좌를 신청인(본인)이 지정하는 계좌로 변경할 수 있다.
3. 제5조, 제8조의 사유로 이용자(본인)가 계약유지가 어렵다고 판단되는 경우 별도의 통지 없이 즉시 입금 지급을 중지하고 계약을 해지 할 수 있다.`,
        },
        {
          title: '제8조 기한의 이익상실',
          content: `한도거래 특약사항 각 호에 해당 하는 경우 기한의 이익상실 사유가 된다.`,
        },
      ],
    }
  },
  methods: {
    open(refName) {
      this.$refs[refName].open()
    },
  },
}
</script>

<style lang="scss" scoped>
.normal-terms {
  padding-bottom: 30px;

  .term-box {
    p {
      margin-bottom: 0;
    }

    &__title {
      font-weight: 600;
      font-size: 16px;
    }

    &__content {
      font-size: 16px;
      line-height: 1.5;
      margin-top: 13px;
    }
  }

  button.collapse {
    width: 100%;
    height: 50px;
    font-weight: 600;
    font-size: 18px;
    color: #727d8c;
    border-radius: 24px;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    margin-top: 20px;
  }
}
</style>
